import React from 'react'
import rootStore from './store'

const rootStoreContext = React.createContext(rootStore)

export default rootStoreContext